import {
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import {
    CAPABILITIES,
    CAPABILITY_LABELS,
    CAPABILITY_SET_NAMES,
    CAPABILITY_SETS
} from '../../capabilities/capabilities';

const CapabilityEditor = ({ value = [], onChange }) => {
    const [capabilities, setCapabilities] = useState(value);
    const [predefinedRole, setPredefinedRole] = useState(CAPABILITY_SET_NAMES.MANAGER);

    useEffect(() => {
        setCapabilities(value);
    }, [value]);

    useEffect(() => {
        let foundCapabilitySet = false;
        Object.entries(CAPABILITY_SET_NAMES).forEach(([key, name]) => {
            const set = CAPABILITY_SETS[name];
            if (JSON.stringify([...set].sort()) === JSON.stringify([...capabilities].sort())) {
                foundCapabilitySet = true;
                setPredefinedRole(name);
            }
        });

        if (!foundCapabilitySet) {
            setPredefinedRole(CAPABILITY_SET_NAMES.CUSTOM);
        }

        if (JSON.stringify([...capabilities].sort()) !== JSON.stringify([...value].sort())) {
            onChange?.(capabilities);
        }
    }, [capabilities, onChange, value]);

    const handleCapabilityToggle = capability => {
        const newCapabilities = capabilities.includes(capability)
            ? capabilities.filter(c => c !== capability)
            : [...capabilities, capability];

        setCapabilities(newCapabilities);
    };

    const handlePredefinedRoleChange = ev => {
        const selectedSet = CAPABILITY_SETS[ev.target.value];
        setCapabilities([...selectedSet]);
        setPredefinedRole(ev.target.value);
    };

    return (
        <>
            <Grid item xs={12} sx={{ mb: 2 }}>
                <FormControl fullWidth>
                    <InputLabel>Predefined roles</InputLabel>
                    <Select
                        label="Roles"
                        value={predefinedRole}
                        onChange={handlePredefinedRoleChange}
                    >
                        {Object.values(CAPABILITY_SET_NAMES).map(preDefRole => (
                            <MenuItem key={preDefRole} value={preDefRole}>
                                {preDefRole}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                Capabilities:
                {Object.values(CAPABILITIES).map((capability, idx) => (
                    <Grid item xs={12} key={idx}>
                        <FormControlLabel
                            label={CAPABILITY_LABELS[capability]}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={capabilities.includes(capability)}
                                    onChange={() => handleCapabilityToggle(capability)}
                                />
                            }
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default CapabilityEditor;
